export default {
  chartData: {}
}
